<template>
  <div class="news_wrap">
    <div class="news_content">
      <div class="news_info">
        <a
          href="javascript:;"
          class="btn_back db"
          @click="$router.push('/mobile/list')"
          >返回</a
        >
        <div class="news_top">
          <h2 class="new_title">{{ newsDetail.title }}</h2>
          <div class="news_time2">
            <em>{{ newsTypeText[newsDetail.type] }}</em>
            <span>{{ formatDate(newsDetail.start_time) }}</span>
          </div>
        </div>
        <div class="news_content_wrap">
          <img
            :src="newsDetail.broadcast_image"
            v-if="newsDetail.broadcast_image"
            alt=""
            class="news_poster"
          />
          <div class="news_content_text">
            <div v-html="newsDetail.content"></div>
          </div>
        </div>
      </div>
      <!-- 相关推荐 -->
      <div class="tj_box" v-if="tjList.length > 1">
        <h3 class="tj_title">相关推荐</h3>
        <div class="tj_swiper">
          <swiper
            class="tj_slider"
            :slidesPerView="2"
            @swiper="onSwiperNews"
            @slideChange="onSlideChangeNews"
          >
            <swiper-slide v-for="item in tjList" :key="item.id">
              <div class="tj_info" @click="showNewsDetail(item.id)">
                <div class="tj_img">
                  <img :src="item.broadcast_image" alt="" />
                </div>
                <div class="tj_txt">
                  <p>{{ item.title }}</p>
                  <em>{{ newsTypeText[item.type] }}</em>
                </div>
              </div>
            </swiper-slide>
            <!-- <swiper-slide>
                            <div class="tj_info">
                                <div class="tj_img"><img src="/img/pc/news_img.jpg" alt="" /></div>
                                <div class="tj_txt">
                                    <p>活动预告 | 深坠异想奇境 燃梦的向</p>
                                    <em>公告</em>
                                </div>
                            </div>
                        </swiper-slide> -->
          </swiper>
          <a
            href="javascript:;"
            v-if="tjList.length > 2"
            :class="tjCur == 0 ? 'tj_prev gray' : 'tj_prev'"
            @click="tjPrev()"
          ></a>
          <a
            href="javascript:;"
            v-if="tjList.length > 2"
            :class="tjCur == tjList.length ? 'tj_next gray' : 'tj_next'"
            @click="tjNext()"
          ></a>
        </div>
      </div>
      <!-- 回到顶部 -->
      <a
        href="javascript:;"
        class="btn_top"
        v-if="topShow"
        @click="scrollTop()"
      ></a>
    </div>
    <!-- 导航 -->
    <div class="top_box">
      <a href="javascript:;" class="top_logo"></a>
      <div class="tright_icon">
        <a
          href="javascript:;"
          :class="bgmState ? 'btn_bgm play' : 'btn_bgm'"
          @click="playBgm()"
        >
          <i></i>
        </a>
        <a href="javascript:;" class="btn_zhuan" @click="showShare()"></a>
      </div>
    </div>
    <!-- 分享浮层 -->
    <div class="share_pop" @click="closeShare()" v-if="sharePop">
      <img src="/img/m/share_fc.png" alt="" />
    </div>
    <!-- bgm -->
    <audio src="media/bgm.mp3" loop preload="auto" autoplay class="bgm"></audio>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/mousewheel";
import SwiperCore, { Mousewheel } from "swiper";
import { useRoute, useRouter } from "vue-router"; // 导入 useRouter
import { formatDate } from "@/utils/formatDate"; // 导入时间格式化函数
import { getCode, makeReservation, getNewsList, getNewsDetail } from "@/api"; // 导入api
import { toast } from "vue3-toastify"; // 引入toast组件
import { updateHtmlBodyImgUrl } from "@/utils/index";
import { homeOnOfficialNewsClickReporting } from "@/utils/reporting";

// 设置html和body的高度为auto
document.documentElement.style.height = "auto";
document.body.style.height = "auto";

function showToast(msg) {
  toast.info(msg);
}

// 双端适配
const router = useRouter(); // 获取路由实例
const route = useRoute();
const detailId = Number(route.query.id); // 获取路由参数
const isPt = () => {
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  if (isMobile) {
    router.push("/mobile/news?id=" + detailId);
  } else {
    router.push("/news?id=" + detailId);
  }
};
onMounted(() => {
  homeOnOfficialNewsClickReporting(detailId);
  isPt();
  setTimeout(() => {
    document.dispatchEvent(new Event("render-event"));
  });
  window.addEventListener("resize", isPt);
});
onUnmounted(() => {
  window.removeEventListener("resize", isPt);
});

// bgm播放
const bgmState = ref(false); // 定义一个ref来保存bgm播放状态
let allbgm = document.querySelector(".bgm"); // 定义一个bgm对象
onMounted(() => {
  allbgm = document.querySelector(".bgm"); // 定义一个bgm对象
  allbgm.play(); // 进入页面播放
  bgmState.value = true;
  document.addEventListener("WeixinJSBridgeReady", function () {
    allbgm.play(); // 进入页面播放
    bgmState.value = true;
  });
});
const playBgm = () => {
  if (bgmState.value) {
    allbgm.pause();
    bgmState.value = false;
  } else {
    allbgm.play();
    bgmState.value = true;
  }
};
document.body.addEventListener(
  "click",
  () => {
    allbgm.play();
    bgmState.value = true;
  },
  { once: true }
);

// 新闻详情
const newsTypeText = ["最新", "新闻", "公告", "活动"]; // 定义新闻类型文本
const newsDetail = ref({});

const handleVideoPlay = () => {
  // 视频播放时执行的方法
  console.log("视频正在播放");
  setTimeout(() => {
    document.querySelector(".bgm").pause();
    bgmState.value = false;
  }, 50);
};
function handleVideoPause() {
  const videoElements = document.querySelectorAll("video");
  videoElements.forEach((video) => {
    video.addEventListener("play", handleVideoPlay);
    video.addEventListener("click", handleVideoPlay);
  });
}

// 获取路由参数
// console.log(detailId);
onMounted(async () => {
  try {
    // 获取新闻详情
    const res1 = await getNewsDetail(detailId);
    newsDetail.value = res1;
    newsDetail.value.content = updateHtmlBodyImgUrl(res1.content);
    // console.log(newsDetail.value);
    setTimeout(() => {
      handleVideoPause();
    }, 200);
  } catch (e) {
    console.warn("调用过程中出现异常：", e);
    window.location.href = "/";
  }
});

// 相关推荐
const mySwiperNews = ref(null); // 定义一个ref来保存Swiper实例
const tjCur = ref(0); // 定义一个ref来保存当前轮播图的索引
const onSwiperNews = (swipern) => {
  mySwiperNews.value = swipern;
};
const onSlideChangeNews = () => {
  if (mySwiperNews.value) {
    tjCur.value = mySwiperNews.value.realIndex;
    // console.log(tjCur);
  }
};
const tjNext = () => {
  mySwiperNews.value.update();
  mySwiperNews.value.slideNext();
};
const tjPrev = () => {
  mySwiperNews.value.update();
  mySwiperNews.value.slidePrev();
};
const tjList = ref([]); // 初始为空数组
onMounted(async () => {
  try {
    // 获取新闻列表
    const res2 = await getNewsList(1, 4, newsDetail.value.type);
    tjList.value = res2.list;
  } catch (e) {
    console.warn("调用过程中出现异常：", e);
  }
});
// 推荐跳转
const showNewsDetail = (id) => {
  router.push("/mobile/news?id=" + id);
  // 刷新页面
  setTimeout(() => {
    window.location.reload();
  }, 100);
};
// 回到顶部
const topShow = ref(false);
const scrollTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth", // 使用浏览器原生平滑滚动
  });
};

window.onscroll = () => {
  if (
    document.documentElement.scrollTop > 100 ||
    document.body.scrollTop > 100
  ) {
    topShow.value = true;
  } else {
    topShow.value = false;
  }
};

// 点击弹出分享指引
const sharePop = ref(false);
const showShare = () => {
  sharePop.value = true;
};
const closeShare = () => {
  sharePop.value = false;
};
</script>

<style lang="scss" scoped>
@use "./m" as m;
</style>
